import { convertDateFormat } from '../../../../../scripts/moment';
const setDataForPut = state => {
  const data = {
    Id: state.Id,
    FirstName: state.FirstName,
    AddressId: state.AddressId,
    LastName: state.LastName,
    NationalityId: state.NationalityId,
    IdentityNbr: state.IdentityNbr,
    StartedJobAt: convertDateFormat(state.StartedJobAt, 'YYYY-MM-DD'),
    TourGuideLanguage: state.TourGuideLanguage.map(data => {
      return {
        ServiceItemId: data.ServiceItemId,
        TourGuideId: state.Id,
        Action: data.Action,
        LanguageId: data.LanguageId,
      };
    }),
    RegionCoverage: state.RegionCoverages,
    AddressObjectRequest: {
      Id: state.AddressId,
      Address1: state.Address1,
      Address2: state.Address2,
      Address3: state.Address3,
      Landmark: state.Landmark,
      PostalCode: state.PostalCode,
      AreaId: state.AreaId,
    },
    EmailAddress: state.EmailAddress,
  };

  return data;
};

export default setDataForPut;
